import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LoadingModal from "./utils/LoadingModal";
import { isAuthenticated } from "./../utils/auth";
import backgroundImage from "../assets/Back.jpg";
import overlay from "../assets/overlay.png";
export default function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [isAuth, setIsAuth] = useState(null);

  useEffect(() => {
    setError(""); // Clear any previous errors
    setLoading(true);
    const checkAuth = async () => {
      const auth = await isAuthenticated();
      setIsAuth(auth);
    };

    checkAuth();
    setLoading(false);
  }, []);

  const handleNavigateHome = () => {
    navigate("/");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(""); // Clear any previous errors
    setLoading(true);
    const data = { username, password, rememberMe };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}auth/login`,
        data,
        {
          withCredentials: true,
        }
      );
      if (response.status === 201) {
        //Login done
        setTimeout(1000); // Timeout to fix navigation between login screen and the dashboard
        window.location.href = "/";
      } else {
        setError("Erreur d'authentification");
      }
    } catch (error) {
      setError(
        "Erreur d'authentification: " +
          (error.response?.data?.message || error.message)
      );
    }
    setLoading(false);
  };

  const handleLogout = async (event) => {
    event.preventDefault();
    setError(""); // Clear any previous errors
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}auth/logout/`,
        { withCredentials: true }
      );

      if (response.status === 200) {
        // Successful logout
        setLoading(false);
        window.location.reload();
      } else {
        setError("Erreur");
      }
    } catch (error) {
      setError("Erreur: " + (error.response?.data?.message || error.message));
    }
    setLoading(false);
  };

  const renderAuthenticatedView = () => (
    <section className="bg-white md:grid md:grid-cols-2 h-screen w-full">
      <div
        className="shadow-lg hidden md:block"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          height: "100%",
          width: "100%",
        }}
      ></div>
      <div
        className="flex flex-col items-center justify-center gap-8 p-6 md:m-1 rounded-md shadow-lg h-full md:h-auto w-full"
        style={{
          backgroundImage: `url(${overlay})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          opacity: 0.7,
        }}
      >
        {loading && <LoadingModal />}
        <h1 className="font-bold text-4xl">Bienvenue</h1>
        <div className="font-medium text-lg text-slate-600 text-center">
          Vous êtes déjà enregistré. Veuillez vous déconnecter si vous souhaiter
          changer de compte :
        </div>

        <div className="flex flex-col gap-4 w-full max-w-md">
          <button
            onClick={()=> window.location.reload()}
            className="py-3 rounded-xl bg-blue-700 text-white text-lg font-bold hover:bg-blue-800 transition-colors"
          >
            Page d'accueil
          </button>
          <button
            onClick={handleLogout}
            className="py-3 rounded-xl bg-red-500 text-white text-lg font-bold hover:bg-red-600 transition-colors"
          >
            Déconnexion
          </button>
        </div>
      </div>
    </section>
  );

  const renderLoginView = () => (
    <section className="bg-white md:grid md:grid-cols-2 h-screen">
      <div
        className="hidden md:block shadow-lg "
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover", // Changed from "100%" to "cover"
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center", // Added this property
          height: "100%", // Added this property
          width: "100%", // Added this property
        }}
      ></div>
      <div
        className="flex flex-col items-center justify-center gap-32 p-6 m-1 md:rounded-md shadow-lg h-full md:h-auto"
        style={{
          backgroundImage: `url(${overlay})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "rgba(255, 255, 255, 0.5)", // Add this for semi-transparent white background
          opacity: 0.7, // Or use this to make the entire div and its contents semi-transparent
        }}
      >
        <h1 className="font-bold text-4xl">Bienvenue</h1>
        <h1 className="text-slate-600">AselMobile Sim-Management</h1>
        {loading && <LoadingModal />}
        <div className="w-full p-4">
          <form onSubmit={handleSubmit}>
            <div>
              <label className="text-md font-medium">Nom d'utilisateur</label>
              <input
                className="w-full border-2 border-gray-100 rounded-xl p-4 mt-1 bg-transparent"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              ></input>
            </div>
            <div>
              <label className="text-md font-medium">Mot de passe</label>
              <input
                className="w-full border-2 border-gray-100 rounded-xl p-4 mt-1 bg-transparent"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              ></input>
            </div>
            <div className="mt-2 flex justify-between items-center">
              <div className="flex items-center">
                <input
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  id="remember"
                  type="checkbox"
                  value=""
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                ></input>

                <label className="ml-2 font-medium text-base" htmlFor="remember">
                  Se souvenir de moi
                </label>
              </div>
            </div>

            {error && <div className="text-red-500 mt-4">{error}</div>}
            <div className="mt-8 flex flex-col gap-y-4">
              <button
                href="/"
                type="submit"
                className="py-3 rounded-xl bg-blue-700 text-white text-lg font-bold"
              >
                Connection
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
  if (loading) {
    return <LoadingModal />;
  }

  if (isAuth === null) {
    return null;
  }

  return isAuth ? renderAuthenticatedView() : renderLoginView();
}
